export const SITE_NAME = 'Otto+Info';
export const SITE_URL = 'https://www.ottoinfo.com';
export const SITE_AUTHOR = 'Matthew Otto';
export const SITE_EMAIL = 'matt@ottoinfo.com';
export const SITE_PHONE = '714.724.6786';
export const SITE_KEYWORDS =
  'matthew otto, developer, full-stack, web developer, react, node.js, typescript, portfolio';
